import videoCardHover from "../../shared/videoCardHover";
import sidePanelControl from "../../shared/search/sidePanelControl";

export default () => {
  videoCardHover();
  sidePanelControl();
};
